import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';
import { ErrorCode } from '@/resources/error/ErrorCode';

export type StateApiError = {
  type: 'warn' | 'redirect' | 'retry';
  i18nTitle: string;
  i18nText: string;
  code: ErrorCode;
  next: (isRetry: boolean) => void;
};

export type State = {
  list: StateApiError[];
  apiCancelCount: number;
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.list = [];
  state.apiCancelCount = 0;
}

const getters: GetterTree<State, RootState> = {
  apiErrorList: (state: State): StateApiError[] => state.list,
  apiCancelCount: (state: State): number => state.apiCancelCount
};

const mutations: MutationTree<State> = {
  setApiErrorList(state: State, payload: StateApiError[]) {
    state.list = payload;
  },

  addApiCancelCount(state: State) {
    state.apiCancelCount++;
  },

  clearState(state: State) {
    clearState(state);
  }
};

const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  },

  addApiError(context: ActionContext<State, RootState>, payload: StateApiError) {
    context.commit('setApiErrorList', context.state.list.concat(payload));
  },

  removeApiError(context: ActionContext<State, RootState>, payload: StateApiError) {
    context.commit(
      'setApiErrorList',
      context.state.list.filter((error: StateApiError): boolean => error !== payload)
    );
  },

  apiCancel(context: ActionContext<State, RootState>) {
    context.commit('addApiCancelCount');
  }
};

export const error: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
